import React from 'react'
import {GoogleLogout} from 'react-google-login'
import store from '../redux'


const clientId = '389209335738-hqmub5i0hcq796ug9be3f3jhr47stm53.apps.googleusercontent.com'

function Logout (props) {
    const onSuccess = (res) => {
        store.dispatch({type:'USER_LOGOUT'})
        console.log('[Logout Success]')
    }

    return (
            <GoogleLogout
                clientId={clientId}
                render={renderProps => (
                    <div onClick={renderProps.onClick} disabled={renderProps.disabled} role="presentation" className="sidenav---sidenav-navitem---uwIJ-">
                        <div className="sidenav---navitem---9uL5T" role="menuitem" tabIndex="-1">
                            <div className="sidenav---navicon---3gCRo">
                                <i className="fa fa-fw fa-sign-out" style={{ fontSize: '1.75em' }} />
                            </div>
                            <div className="sidenav---navtext---1AE_f">
                                Keluar
                            </div>
                        </div>
                    </div>
                )}
                buttonText="Logout"
                onLogoutSuccess={onSuccess}
            />
    )
}

export default Logout